import { Link } from 'react-router-dom';
import { LegalLayout } from '../../components/LegalLayout';

export function CGVPage() {
  return (
    <LegalLayout
      title="Conditions générales de vente (CGV)"
      lead="Dernière mise à jour : juillet 2026 · Achat du mode infini Dezoom"
    >
      <h2>1. Vendeur</h2>
      <p>
        <strong>Florian Augeard</strong> — PrograGames<br />
        49000 Angers, France · SIREN 106 684 780 · RCS Angers<br />
        Contact :{' '}
        <a href="https://progragames.com/contact.html" target="_blank" rel="noopener noreferrer">
          progragames.com/contact
        </a>
      </p>

      <h2>2. Produits</h2>
      <p>Les achats portent sur du <strong>contenu numérique</strong> activable immédiatement sur ton compte Dezoom :</p>
      <table className="legal-table">
        <thead>
          <tr>
            <th>Produit</th>
            <th>Description</th>
            <th>Prix (EUR)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Mode infini (à vie)</td>
            <td>Énigmes illimitées (banque premium), arène classée Elo, galerie premium</td>
            <td>3,00 €</td>
          </tr>
        </tbody>
      </table>
      <p>
        Les prix affichés in-game prévalent en cas de divergence.{' '}
        <strong>TVA non applicable, article 293 B du Code général des impôts</strong> (franchise en base de TVA).
      </p>

      <h2>3. Commande et paiement</h2>
      <p>
        Les achats sont réservés aux utilisateurs disposant d'un compte connecté.
        Le paiement est effectué via <strong>Stripe</strong> (carte bancaire).
        PrograGames ne conserve pas tes coordonnées bancaires complètes.
      </p>

      <h2>4. Livraison</h2>
      <p>
        Le contenu numérique est <strong>activé immédiatement</strong> sur ton compte après confirmation du paiement.
        En cas d'échec d'activation automatique, contacte le support avec l'identifiant de session Stripe.
      </p>

      <h2>5. Droit de rétractation</h2>
      <p>
        Conformément aux articles L221-18 et suivants du Code de la consommation, tu disposes d'un délai de{' '}
        <strong>14 jours</strong> pour te rétracter, sauf exception pour le contenu numérique.
      </p>
      <p>
        Conformément à l'article <strong>L221-28</strong>, le droit de rétractation ne peut être exercé si
        l'exécution a commencé avec ton <strong>accord exprès</strong> et ta{' '}
        <strong>renonciation expresse</strong> au droit de rétractation, une fois le contenu délivré sur ton compte.
      </p>
      <p>
        Avant chaque achat, tu dois confirmer accepter les présentes CGV et demander l'exécution immédiate
        du contenu numérique.
      </p>

      <h2>6. Remboursements</h2>
      <ul>
        <li>Contenu <strong>non livré</strong> : remboursement ou activation après vérification.</li>
        <li>Contenu <strong>déjà activé</strong> : pas de remboursement, sauf obligation légale ou erreur avérée imputable au vendeur.</li>
        <li>Réclamation : via le{' '}
          <a href="https://progragames.com/contact.html" target="_blank" rel="noopener noreferrer">
            formulaire de contact
          </a>{' '}
          dans un délai raisonnable.
        </li>
      </ul>

      <h2>7. Médiation</h2>
      <p>
        En cas de litige non résolu, tu peux recourir gratuitement au médiateur{' '}
        <strong>CM2C</strong> — 49 rue de Ponthieu, 75008 Paris —{' '}
        <a href="https://www.cm2c.net/" target="_blank" rel="noopener noreferrer">www.cm2c.net</a>
      </p>

      <h2>8. Litiges</h2>
      <p>
        Plateforme européenne ODR :{' '}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
          ec.europa.eu/consumers/odr
        </a>
        .
      </p>

      <h2>9. CGU</h2>
      <p>
        L'utilisation du jeu reste soumise aux <Link to="/cgu">CGU</Link>.
      </p>
    </LegalLayout>
  );
}
